import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { ADMIN_ROLE } from "constants/auth-types"

import MediaPlayer from "components/common/MediaPlayer"

import { saveProgress, completeCourseware } from "store/user/actions"

class Audio extends Component {
  state = {
    mediaProgress: {
      loaded: 0,
      loadedSeconds: 0,
      played: 0,
      playedSeconds: 0,
    },
  }

  componentWillUnmount() {
    this.saveProgress()
  }

  getMediaProgress = (value) => {
    this.setState({ mediaProgress: value })
  }

  saveProgress = () => {
    const { data, saveProgress } = this.props
    const {
      mediaProgress: { playedSeconds },
    } = this.state

    if (data?.seconds < playedSeconds) {
      let saveData = {
        courseware_id: data.id,
        seconds: playedSeconds,
      }

      saveProgress({ data: saveData })
    }
  }

  onEndedMedia = () => {
    const { data, completeCourseware } = this.props
    if (!data.completed) {
      completeCourseware({ id: data.id })
    }
  }

  render() {
    const {
      data,
      sessionPaused,
      auth: { role },
    } = this.props

    const lastProgress = !data?.completed ? data?.seconds : 0
    const forwardStreaming = !data?.completed ? data?.forward_streaming : true
    const isAdmin = ADMIN_ROLE.includes(role)

    return (
      <>
        <div className="courseware-details">
          <h2 className="courseware-title">{`${data.name}`}</h2>
          {data.description && (
            <p className="courseware-description">{data.description}</p>
          )}
        </div>
        <MediaPlayer
          media={`${data.file}`}
          onGetMediaProgress={this.getMediaProgress}
          onEndedMedia={this.onEndedMedia}
          lastProgress={lastProgress}
          type={data.type}
          forwardStreaming={forwardStreaming || isAdmin}
          sessionPaused={sessionPaused}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ saveProgress, completeCourseware }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Audio)
